exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".goods-box[data-v-f69dd6f8]{padding:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-f69dd6f8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/Dynamics/DynamicManage/GoodsDetail.vue
// module id = 645
// module chunks = 0